import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as DownArrow } from 'src/assets/images/arrow-down.svg';
import { ReactComponent as UpArrow } from 'src/assets/images/arrow-up.svg';
import { ReactComponent as Close } from 'src/assets/images/close.svg';
import styles from './styles.module.css';

export default function NurtureBarStep(props) {
  const viewStepCTA = props.step.completed ? 'See Goal Again' : props.step.buttonText;
  const disableIfFirstStep = () => (props.index === 0 ? styles.disabled : '');
  const disableIfLastStep = () => (props.index === props.totalSteps - 1 ? styles.disabled : '');
  const animationDuration = 150;
  const [currentAnimation, playAnimation] = useState(styles.slideUpIn);

  const goToNextStep = (event) => {
    if (!disableIfLastStep()) {
      playAnimation(styles.slideUpOut);

      // Wait until the slideUpOut animation has completed
      setTimeout(() => {
        props.goToNextStep(); // Update step props
        playAnimation(styles.slideUpIn);
      }, animationDuration);
    }

    // Remove focus after interaction
    event.currentTarget.blur();
  };

  const goToPreviousStep = (event) => {
    if (!disableIfFirstStep()) {
      playAnimation(styles.slideDownOut);

      // Wait until the slideDownOut animation has completed
      setTimeout(() => {
        props.goToPreviousStep(); // Update step props
        playAnimation(styles.slideDownIn);
      }, animationDuration);
    }

    // Remove focus after interaction
    event.currentTarget.blur();
  };

  return (
    <div className={styles.nurtureBarStep}>
      <div className={`${styles.stepControls} ${styles.right}`}>
        <span role="button" tabIndex="0" onKeyPress={props.closeStep} onClick={props.closeStep}>
          <Close />
        </span>
      </div>
      <div className={`${styles.stepControls} ${styles.left}`}>
        <span
          data-test="up-arrow"
          role="button"
          tabIndex="0"
          onKeyPress={event => goToPreviousStep(event)}
          onClick={event => goToPreviousStep(event)}
          className={disableIfFirstStep()}
        >
          <UpArrow />
        </span>
        <span
          data-test="down-arrow"
          role="button"
          tabIndex="0"
          onKeyPress={event => goToNextStep(event)}
          onClick={event => goToNextStep(event)}
          className={disableIfLastStep()}
        >
          <DownArrow />
        </span>
      </div>
      <div data-test="goal-description" className={`${styles.stepDescription} ${styles.stepNavigation} ${currentAnimation}`}>
        <span
          onClick={() => props.viewStep(viewStepCTA)}
          onKeyPress={() => props.viewStep(viewStepCTA)}
          role="button"
          tabIndex="0"
        >
          {`Goal #${props.index + 1}: ${props.step.text}`}
          {props.step.completed
            && (
              <span>
                {' - '}
                <span className={styles.stepCompleted}>all done!</span>
              </span>
            )}
        </span>
        <button
          className={styles.btnViewNow}
          type="button"
          onClick={() => props.viewStep(viewStepCTA)}
          data-test="view-step-button"
        >
          {viewStepCTA}
        </button>
      </div>
    </div>
  );
}

NurtureBarStep.propTypes = {
  index: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  step: PropTypes.shape({
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    audienceKey: PropTypes.string.isRequired,
    completed: PropTypes.bool.isRequired,
    buttonText: PropTypes.string.isRequired,
  }).isRequired,
  goToPreviousStep: PropTypes.func.isRequired,
  goToNextStep: PropTypes.func.isRequired,
  closeStep: PropTypes.func.isRequired,
  viewStep: PropTypes.func.isRequired,
};
